<template>
    <section class="guest-maintenance">
        <img v-if="logo && !logoMissing" :src="logo" alt="" class="guest-maintenance__logo" @error="logoMissing = true">
        <p class="guest-maintenance__text">
            Découvrez prochainement l'ensemble des outils du projet {{ projectName }}
        </p>
    </section>
</template>

<script>
    import { maintenanceLogo, maintenanceProjectName } from "../composables/guestMaintenance";

    export default {
        data() {
            return {
                logoMissing: false,
            }
        },
        computed: {
            domain() {
                return this.$store.state.frontoffice.domain;
            },
            settings() {
                return this.domain?.settings?.data || [];
            },
            logo() {
                return maintenanceLogo(this.settings);
            },
            projectName() {
                const locale = this.$store.state.config.locale;
                const fromProject = maintenanceProjectName(this.domain?.projects?.data, locale);

                if (fromProject !== '') {
                    return fromProject;
                }

                const translated = this.domain?.translatable?.name?.[locale];

                if (typeof translated === 'string' && translated.trim() !== '') {
                    return translated.trim();
                }

                return typeof this.domain?.name === 'string' ? this.domain.name : '';
            },
        },
    }
</script>

<style>
    .guest-maintenance {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 2.5rem 1.5rem;
        background: #fff;
    }

    .guest-maintenance__logo {
        width: min(420px, 80vw);
        height: auto;
    }

    .guest-maintenance__text {
        margin: 2.5rem 0 0;
        max-width: 36rem;
        font-size: 1.25rem;
        line-height: 1.5;
        color: #111;
    }
</style>
